import _extends from "@babel/runtime/helpers/extends";
import React, { useImperativeHandle } from 'react';
import { useCircle } from './useCircle';
export * from './useCircle';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    circle
  } = useCircle(props);
  useImperativeHandle(ref, () => _extends({}, props, {
    circle
  }));
  return null;
});